// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"F3-z"};